export const generateID = function () {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  const hash = Math.random().toString(36).slice(-7);
  return `${prefix}-${hash}`;
};